import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconDirective } from '@view/shared/atoms/icons';
import { Lego } from '@domain/models/task/task';

@Component({
  selector: 'app-list-item-mol',
  standalone: true,
  imports: [CommonModule, IconDirective],
  template: `
    <div class="flex">
      <div class="flex-1">
        <i
          *ngIf="iconId"
          appIcon
          [icon]="isExpanded && legos ? 'folder-open' : iconId"
          [ngClass]="{ 'cursor-pointer': legos?.length }"
          class="mr-1"
          (click)="toggleExpanded()"
        ></i>
        <a
          *ngIf="link"
          appTextContentAtm
          href="#"
          (click)="onDocumentationRedirect($event, link)"
          >{{ text }}</a
        >
        <span *ngIf="!link" appTextContentAtm>{{ text }}</span>
        <div
          *ngIf="legos?.length && isExpanded"
          class="mt-1 text-sm rk-lego-archetype border-l border-gray-300 pl-2"
        >
          <div *ngFor="let lego of legos">{{ lego.name }}</div>
        </div>
      </div>
      <i
        class="rk-list-item-delete"
        *ngIf="canDelete"
        appIcon
        icon="trash"
        (click)="onDelete()"
      ></i>
    </div>
  `,
  styles: []
})
export class ListItemMolComponent {
  @Input() id = '';
  @Input() link = '';
  @Input() text = '';
  @Input() legos?: Lego[];
  @Input() canDelete = false;
  @Input() documentationRedirect = true;
  @Input() iconId = '';
  protected isExpanded = false;

  @Output() deleted = new EventEmitter<string>();

  onDocumentationRedirect(e: Event, url: string) {
    e.preventDefault();
    if (this.documentationRedirect) {
      window.open(url, '_blank');
    }
  }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }

  onDelete() {
    this.deleted.emit(this.id);
  }
}
